export default ngModule => {

    ngModule.directive('activeQuoteBanner', () => {
        return {
            restrict: 'E',
            template: require('./active-quote-banner.html'),
            scope: {
                application: '=',
            },
        };
    });

}



// WEBPACK FOOTER //
// ./src/directives/active-quote-banner.js